if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = this.getCart();
      this.submitButton = this.querySelector('[type="submit"]');
      this.spinner = this.querySelector('.loading-overlay__spinner');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      // Hide/show slider buttons based on visible images
      const productImages = document.querySelectorAll('.thumbnail-list__item');
      const sliderButtons = document.querySelectorAll('.trellis-product__media-wrapper .slider-button');
      const totalVariantSpecificImages = document.querySelectorAll('.thumbnail-list__item-variant-specific');
      const visibleVariantSpecificImages = document.querySelectorAll('.thumbnail-list__item-variant-specific--active');

      if (productImages && sliderButtons && totalVariantSpecificImages) {
        // Visible image count is equal to the total image count, minus the total variant specific image count, plus the visible variant specific image count
        const visibleImgCount = (productImages.length - totalVariantSpecificImages.length) + visibleVariantSpecificImages.length;
  
        // If there are fewer than five, hide the slider buttons
        if (visibleImgCount <= 5) {
          sliderButtons.forEach((sliderButton) => {
            sliderButton.style.display = 'none';
          });
        } else {
          sliderButtons.forEach((sliderButton) => {
            sliderButton.style.display = 'block';
          });
        }
      }
    }

    // Only treat the theme cart element as a cart when its custom element has
    // actually been upgraded (its script loaded). The header renders a
    // `<cart-notification>` but `cart-notification.js` is not loaded on this
    // theme because Rebuy Smart Cart is the customer-facing cart. Calling
    // `getSectionsToRender()` on the plain, un-upgraded element threw inside the
    // submit handler after the button had already been put into its
    // disabled/loading state, so the button stayed grey and the cart API was
    // never called.
    getCart() {
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (!cart) return null;
      const isUpgraded = typeof cart.getSectionsToRender === 'function' && typeof cart.renderContents === 'function';
      return isUpgraded ? cart : null;
    }

    setLoading(isLoading) {
      this.submitButton.classList.toggle('loading', isLoading);
      if (this.spinner) this.spinner.classList.toggle('hidden', !isLoading);
      if (isLoading) {
        this.submitButton.setAttribute('aria-disabled', true);
      } else if (!this.error) {
        this.submitButton.removeAttribute('aria-disabled');
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      // Custom elements may upgrade after this element was constructed, so
      // resolve the cart at submit time.
      this.cart = this.getCart();

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        // Rebuy Smart Cart is the customer-facing cart on this store. Re-rendering
        // the theme's heavy `cart-drawer` section on every add was a redundant
        // ~10KB server render that piled onto the cart-API requests tripping
        // Shopify's 429 rate limit. Skip it and only refresh the lightweight cart
        // count bubble; Rebuy opens the cart UI itself.
        const sectionsToRender = this.cart
          .getSectionsToRender()
          .map((section) => section.id)
          .filter((id) => id !== 'cart-drawer');
        formData.append('sections', sectionsToRender);
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      } else {
        // No theme cart component: still refresh the header cart count.
        formData.append('sections', 'cart-icon-bubble');
        formData.append('sections_url', window.location.pathname);
      }
      config.body = formData;

      // Put the button into its loading state only once the request is ready to
      // send, so nothing above can leave it stuck disabled.
      this.setLoading(true);

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          this.error = false;

          if (!this.cart) {
            this.updateCartIconBubble(response);
            return;
          }

          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          this.setLoading(false);
          
          // If a gift card was added re-load the window
          if (this.querySelector('.form--gift-card')) location.reload();
        });
    }

    updateCartIconBubble(response) {
      const bubble = document.getElementById('cart-icon-bubble');
      const html = response.sections && response.sections['cart-icon-bubble'];
      if (!bubble || !html) return;
      const section = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
      if (section) bubble.innerHTML = section.innerHTML;
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
